export type CustomerGrade = 'A_PLUS' | 'A' | 'B' | 'C' | 'GREY_LIST' | 'BLACK_LIST' | ''

export type ResponsibilityOwner = 'PACO' | 'CUSTOMER' | null

export interface ProductionFactoryEntry {
  enabled: boolean
  percent: string
}

export interface ProductionFactoriesState {
  factory1: ProductionFactoryEntry
  factory2: ProductionFactoryEntry
  factory3: ProductionFactoryEntry
  joint: ProductionFactoryEntry
}

export interface DocumentsState {
  soil: boolean
  site: boolean
  contract: boolean
  cert: boolean
  vat: boolean
  other: boolean
  otherDetail: string
}

export interface ResponsibilityRow {
  rowIndex: number
  owner: ResponsibilityOwner
}

export interface ProductionOrderItem {
  id: string
  no: string
  item: string
  quantity: string
  pricePerQ: string
  pilePerUnit: string
  drivingPerUnit: string
  other: string
  pileAndDrivingPerUnit: string
}

export interface ProductionOrderRequestFormState {
  specialPillarEnabled: boolean
  specialPillarDate: Date | null
  specialStopEnabled: boolean
  specialStopCount1: string
  specialStopCount2: string
  specialOtherEnabled: boolean
  specialOtherDetail: string
  items: ProductionOrderItem[]
  productionFactories: ProductionFactoriesState
  productionCompany: string
  documents: DocumentsState
  customerGrade: CustomerGrade
  depositPercent: string
  depositAmount: string
  financeNote: string
  responsibility: ResponsibilityRow[]
}

export const RESPONSIBILITY_ROW_COUNT = 14

export type ProductionOrderRequestApiPayload = {
  specialPillarEnabled: boolean
  specialPillarDate: string | null
  specialStopEnabled: boolean
  specialStopCount1: number | null
  specialStopCount2: number | null
  specialOtherEnabled: boolean
  specialOtherDetail: string | null
  items: {
    no: string | null
    item: string | null
    quantity: string | null
    pricePerQ: string | null
    pilePerUnit: string | null
    drivingPerUnit: string | null
    other: string | null
    pileAndDrivingPerUnit: string | null
  }[]
  productionFactories: {
    factory1: { enabled: boolean; percent: number | null }
    factory2: { enabled: boolean; percent: number | null }
    factory3: { enabled: boolean; percent: number | null }
    joint: { enabled: boolean; percent: number | null }
  }
  productionCompany: string | null
  documents: {
    soil: boolean
    site: boolean
    contract: boolean
    cert: boolean
    vat: boolean
    other: boolean
    otherDetail: string | null
  }
  customerGrade: CustomerGrade | null
  depositPercent: number | null
  depositAmount: number | null
  financeNote: string | null
  responsibility: { rowIndex: number; owner: ResponsibilityOwner }[]
}
